module.exports = __webpack_public_path__ + "img/part-two-2.67dbf007.png";